/* eslint-disable */

interface AlignmentSetting {
  type: string;
  icon: string;
}

// We only allow x amount of files to be uploaded at once.
// This limit is enforced in our file upload queue.
export const MAX_FILE_UPLOADS_PERMITTED: number = 1;

// We need to limit this so that the canvas doesn't get overloaded with images
export const MAX_IMAGES_ALLOWED_PER_CANVAS: number = 1;

// Basic placeholder text for a text box that gets added to the canvas
export const TEXT_BOX_PLACEHOLDER_TEXT: string = "Place text here...";

// We need a limit so that the canvas doesn't get too out of control
export const MAX_TEXT_BOX_ALLOWED_PER_CANVAS: number = 1;

// This percentage is used to resize an image when added to the canvas where it's height or width exceeds canvas dimensions
export const IMAGE_RESIZE_PADDING_AMOUNT: number = 0.15;

// We want to set a max font size so that we know how to scale the font
export const TEXT_BOX_MAX_FONT_SIZE: number = 40;

export const TextControlTypes = { left: "left", center: "center", right: "right"};

// controls for the front the text alignment icons
export const TEXT_CONTROLS_ALIGNMENT_SETTINGS: AlignmentSetting[] = [
  {
    type: TextControlTypes.left,
    icon:
      "//cdnimg.webstaurantstore.com/uploads/images/2017/9/customize-align-left.png",
  },
  {
    type: TextControlTypes.center,
    icon:
      "//cdnimg.webstaurantstore.com/uploads/images/2017/9/customize-align-center.png",
  },
  {
    type: TextControlTypes.right,
    icon:
      "//cdnimg.webstaurantstore.com/uploads/images/2017/9/customize-align-right.png",
  },
];

// These are important for us using enlivenCanvasObjects, since it doesn't properly transfer fabricjs object properties as we would like
export const TEXT_BOX_PROPERTIES_TO_TRANSFER: string[] = [
  "top",
  "left",
  "height",
  "width",
  "scaleX",
  "scaleY",
  "clientIdentifier",
  "zIndex",
  "angle",
  "text",
  "fontFamily",
  "fontSize",
  "fill",
  "textAlign",
];

// properties to make text better visible on the scene.
export const TEXT_BOX_SCENE_ADDITIONAL_PROPERTIES = {
  fill: "white",
  strokeWidth: 4,
  stroke: "black",
};
// extended image properties we want to save
export const IMAGE_PROPERTIES_TO_TRANSFER: string[] = [
  "top",
  "left",
  "height",
  "width",
  "scaleX",
  "scaleY",
  "clientIdentifier",
  "zIndex",
  "angle",
];

// hard coded multi regions
export const MULTI_REGION_CONTROL_OPTIONS = {};

// Specific file input name used to upload. Don't change this.
export const IMAGE_UPLOAD_FIELD_NAME = "imageFile";

export const SUPPORTED_FILE_TYPES = [".png", ".jpg", ".eps", ".ai", ".pdf", ".tiff"];
